import React from "react";
import Grid from "@material-ui/core/Grid";
import backgroundImage from "../../../../assets/images/main_background.png";
import StartButton from "../../../../components/pageComponents/Home/LeagueStart/StartButton";
import {withRouter,Redirect} from "react-router-dom";
import axios from "axios";
import {sessionNew, userData} from "../../../../Utility/Url";
import Mesh from "../../../../assets/images/vijee.png";
import Money from "../../../../assets/images/money.png";
import boronz from "../../../../assets/images/boronz.png";
import background from "../../../../assets/images/back.png";
import GreenButton from "../../../../assets/images/green_btn.png";
import Rocket from "../../../../assets/images/rocket_paye.png";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "../../Common/Dialog";
import Dialog from "@material-ui/core/Dialog";
import Fail from "../../../../assets/images/ic_faild.png";
import {connect} from "react-redux";
import {data as rxData} from "../../../../Store/Actions/DataAction";
import {COINCHANGE} from "../../../../Store/Actions/Types";


class TotalPrizeIntro extends React.Component{
    constructor() {
        super();
        this.state={
            sessionValid:false,
            sessionId:undefined,
            customDialogData:null,
            customDialogShow:false,
        }
    }
    componentDidMount() {
    }
    sessionNew= async(id,type)=>{
        await axios.post(sessionNew,{
            id:id,
            type:type
        })
            .then(res => {
                const {data}=res
                if (!data.success){
                    this.setState({
                        customDialogData:data.dialog,
                        customDialogShow:true,
                    })

                    return false
                }
                const {startButtonIconText}=this.props.data
                this.props.rxData({coinType:'silver',value:startButtonIconText,type:'decrement'},COINCHANGE)
                this.setState({
                    sessionId:data.sessionID,
                    sessionValid:true
                })
                return true
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    handleDialogAction=(action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    customDialogShow:false
                })
                break
            case '#shop':
                this.props.history.push('/shop')
                break
            default:
                this.setState({
                    showDialog:false,
                })
        }
    }
    render() {
        const{
            name,
            id,
            totalPrize,
            score,
            timeRemaining,
            backgroundColor,
            backgroundImage,
            prizeIcon,
            startButtonImage,
            startButtonText,
            startButtonIcon,
            startButtonIconText,
            leftSectionBottomImage,
            leftSectionTopImage
        }
            =this.props.data
        const startButton={
            backgroundImage:startButtonImage,
            text:startButtonText,
            icon:startButtonIcon,
            iconText:startButtonIconText
        }
        const{sessionId,sessionValid,customDialogData,customDialogShow}=this.state
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog: {...customDialogData,icon:Fail},
            }
        }
        return(
            <Grid justify={'center'} xs={12} sm={12} item container style={{position:'relative',backgroundImage:'red',overflow:'visible'}}>

                <Dialog
                    // disableBackdropClick
                    open={customDialogShow}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <CustomDialog action={this.handleDialogAction} data={customDialog}/>
                    </DialogContent>
                </Dialog>
                <img  className={'league-top-image'} style={{width:'30%'}} src={boronz} alt=""/>
                <Grid container style={{
                    backgroundImage: "url(" + background + ")",
                    backgroundSize:'100% 100%',
                    backgroundRepeat: 'no-repeat',
                    width:'100%',
                    backgroundColor:backgroundColor,
                    backgroundBlendMode:'soft-light',
                    position:'relative',
                    clipPath: 'polygon(3% 0%, 97% 0px, 100% 5%, 100% 94%, 96% 101%, 3% 100%, 0px 95%, 0px 5%)'
                }}
                      className={'league'} alignItems={"center"} justify={"center"}
                >
                     <Grid justify='flex-end' alignItems={"center"} item container style={{position:'relative'}} >
                            <Grid sm={5} xs={5} item container direction='row-reverse' justify={"center"}>
                               <p>
                                   {name}
                               </p>
                            </Grid>
                        </Grid>
                    <Grid justify='center' alignItems={"center"} item container style={{position:'relative'}} >
                            <Grid sm={12} xs={12} item container direction='row-reverse' justify={"center"} >
                               <p>
                                   تصاویر رو حدس بزن به مسیرت ادامه بده
                               </p>
                            </Grid>
                        </Grid>
                        <Grid item container justify={"center"} >
                            <Grid sm={7} xs={7} onClick={()=>{
                                this.sessionNew(id,'normal')
                            }}>
                                <StartButton data={startButton}/>
                            </Grid>
                        </Grid>

                </Grid>
                { sessionValid &&
                    <Redirect
                        to={{
                            pathname: "/league-start/question",
                            state: { sessionId: sessionId,gameType:'normal'}
                        }}
                    />
                }
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{rxData})(withRouter (TotalPrizeIntro))
